import { Grid } from 'ag-grid-community';
import * as firebase from 'firebase/app';
import {
  getDatabase,
  get,
  child,
  onValue,
  ref,
} from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyCogsr653Buu6OmmmlJcz1bhOW_WXq0W4U",
  authDomain: "newdirectory-d325c.firebaseapp.com",
  projectId: "newdirectory-d325c",
  storageBucket: "newdirectory-d325c.appspot.com",
  messagingSenderId: "383313233622",
  appId: "1:383313233622:web:944c6f9e0569d89bfaeb77",
  databaseURL: "https://newdirectory-d325c-default-rtdb.firebaseio.com",
};
// Initialize Firebase
const appT = firebase.initializeApp(firebaseConfig);
const database = getDatabase(appT);

const refDb = ref(database, "/contacts");

const gridDirectoryOptions: any = {
  // each entry here represents one column
  columnDefs: [
    {
      field: "displayName", width: 250,
    },
    {
      field: "businessPhone",
    },
    {
      field: "email", width: 250,
    },
  ],

  // default col def properties get applied to all columns
  defaultColDef: {
    sortable: true,
    filter: true,
  },

  rowSelection: "multiple", // allow rows to be selected
  animateRows: true, // have rows animate to new positions when sorted

  // example event handler
  onCellClicked: (params: any) => {
    console.log("cell was clicked", params);
  },
};

// get div to host the grid
const eDirectoryGridDiv  = document.getElementById("myDirectoryGrid")!;
// new grid instance, passing in the hosting DIV and Grid Options
new Grid(eDirectoryGridDiv, gridDirectoryOptions);
document.addEventListener("DOMContentLoaded", () => {
  runDirectory();
  setTimeout(() => {
    runDirectory();
  }, 5000);
});

function runDirectory() {
  const allData: any = [];
  console.log("running...");

  onValue(refDb, (snapshot : any) => {
    console.log("Onvalue");
    const snapshotExist = snapshot.val();
    if (snapshotExist !== null) {
      console.log("Snapshot");
      snapshot.forEach((childSnapshot : any) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        allData.push(childData);
      });
    } else {
      console.log("No data available");
    }
  });
  const filterData = allData.sort((a: any, b: any) => (a.email > b.email ? 1 : -1));
  console.log(allData);
  gridDirectoryOptions.api.setRowData(allData);
}
